export default "__VITE_ASSET__D4oK$qR1__"